<template>
  <div class="container" :style="{width: screenWidth + 'px', height: screenHeight + 'px'}">
    <div class="box">
      <h2>注册武术赛事报名系统</h2>
      <el-input style="margin-top: 10px" placeholder="请输入账号" v-model="account"/>
      <el-input style="margin-top: 10px" placeholder="请输入密码" v-model="password" show-password autocomplete="off"/>
      <el-input style="margin-top: 10px" placeholder="请再次输入密码" v-model="agPassword" show-password
                autocomplete="off"/>
      <el-input style="margin-top: 10px" placeholder="请输入邮箱" v-model="email"/>
      <el-input style="margin-top: 10px" placeholder="请输入手机号" v-model="phone"/>
      <div
          style="display: flex;flex-direction: row;justify-content: flex-start;align-items: center;width: 100%;margin-top: 10px">
        <el-input placeholder="请输入手机号验证码" v-model="code"/>
        <el-button type="primary" style="margin-left: 10px" :disabled="timerNum<60||timerNum===0"
                   @click="sendCodeAction">
          <span v-if="timerNum===60||timerNum===0">获取验证码</span>
          <span v-else>{{ timerNum }}s</span>
        </el-button>
      </div>
      <div class="login_btn" @click="loginAction">注册</div>
      <div class="register_btn" @click="toRegister">已经有账号,直接登录</div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

import {register, sendCode} from "@/api/index";
import {MessageBox, Message} from "element-ui";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Login",
  data() {
    return {
      account: "",
      password: "",
      agPassword: "",
      email: "",
      phone: "",
      code: "",
      timer: null,
      timerNum: 60
    };
  },
  computed: {
    ...mapState([
      "screenHeight",
      "screenWidth"
    ])
  },
  methods: {
    sendCodeAction() {
      if (this.phone.length === 0) {
        Message.error("手机号不能为空!");
        return;
      }
      sendCode({
        phone: this.phone,
      }).then(res => {
        if (res.data.code === 200) {
          Message.success("短信发送成功!")
          this.code = "123456"
          this.timer = setInterval(() => {
            if (this.timerNum > 0) {
              this.timerNum--;
            } else {
              this.timerNum = 60
              clearInterval(this.timerNum);
            }
          }, 1000)
        } else {
          Message.success("短信发送失败!")
        }
      })
    },
    toRegister() {
      this.$router.push({
        path: "/login"
      });
    },
    loginAction() {
      if (this.account.length === 0) {
        Message.error("账号不能为空!");
        return;
      }
      if (this.password.length === 0) {
        Message.error("密码不能为空!");
        return;
      }
      if (this.password !== this.agPassword) {
        Message.error("两次输入密码不一致!");
        return;
      }
      if (this.email.length === 0) {
        Message.error("邮箱不能为空!");
        return;
      }
      if (this.phone.length === 0) {
        Message.error("手机号不能为空!");
        return;
      }
      if (this.code.length === 0) {
        Message.error("验证码不能为空!");
        return;
      }
      register({
        email: this.email,
        phone: this.phone,
        account: this.account,
        password: this.password,
        permission: "报名用户",
        code: this.code
      }).then((res) => {
        if (res.data.code === 200) {
          Message.error("注册成功!");
          this.$router.push("/login");
        } else {
          Message.error(res.data.result);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width:100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url("../assets/bg.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .box {
    width: 400px;
    padding: 30px;
    background-color: white;
    border-radius: 8px;

    .login_btn {
      width: 100%;
      background-color: #1FA4FF;
      margin-top: 40px;
      height: 40px;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      cursor: pointer;
    }

    .register_btn {
      font-size: 15px;
      margin-top: 15px;
      cursor: pointer;
    }
  }
}
</style>
